import React, { useMemo } from 'react'
import { useAuth } from '../auth/AuthContext'
import { createMenuVisibilityContext } from '../lib/menu'
import { collectOverviewSections } from '../lib/menu/menuOverviewSections'
import MenuOverviewList from '../components/MenuOverviewList'

export default function MenuOverviewPage() {
  const { user, hasAnyRole, hasAnyPermission, hasAnyCapability } = useAuth()

  const menuCtx = useMemo(
    () => createMenuVisibilityContext(user, { hasAnyRole, hasAnyPermission, hasAnyCapability }),
    [user, hasAnyRole, hasAnyPermission, hasAnyCapability],
  )

  const blocks = useMemo(() => collectOverviewSections(menuCtx), [menuCtx])

  return (
    <section className="space-y-6">
      <h1 className="text-3xl font-bold text-slate-900">메뉴 전체보기</h1>
      <MenuOverviewList blocks={blocks} />
    </section>
  )
}
